import Flex from 'components/Flex'
import React, { useEffect, useRef, useState } from 'react'

import { Col, Row, Tooltip } from 'antd'
import Button from 'components/Button/index'
import CalenderStyled from 'components/CalenderStyle/CalenderStyled'
import AbsentIcon from 'components/icons/AbsentIcon'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import ResumeDownload from 'components/icons/DriveTableIcon/ResumeDownload'
import HoldtocompareIcon from 'components/icons/HoldtocompareIcon'
import LeftArrowIcon from 'components/icons/LeftArrowIconcircle'
import RightArrowIconcircle from 'components/icons/RightArrowIconcircle'
import SelectTickIcon from 'components/icons/SelectTickIcon'
import InfoCards from 'modules/InterviewerDashboard/Partials/DashboardCards'
import EmptyCard from 'modules/InterviewerDashboard/Partials/DashboardCards/EmptyCard'
import TimeCard from 'modules/InterviewerDashboard/Partials/DashboardCards/TimeCard'
import DownlaodUpload from 'modules/InterviewerDashboard/Partials/DashboardRoles/Partial/DownloadAndUpload/index'
import {
  CardRow,
  CarouselWrapper,
  DriveModeText,
  HeaderFlex,
  LeftArrow,
  RightArrow,
  ScrollContainer,
  Statustext,
  UserName,
  Wrapper,
} from 'modules/InterviewerDashboard/Partials/style'
import { getSingleRoleData } from 'modules/Roles/actions'
import InterviewerTabel from '../DashboardRoles/InterviewerTabel/index'
import PreviewRoleDrawer from './Partial/JobDetailDrawer'

import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import {
  bulkFileUploadStatus,
  getListOfCandidateForRoleTOInterview,
  getListOfDatesInterviewer,
  getListOfRolesForInterviwer,
} from 'modules/InterviewerDashboard/actions'
import { resumeBulkDownloadJobRoles } from 'modules/Drives/actions'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { useParams } from 'react-router-dom'
import SuccessMessage from 'utils/SuccessMessage'
import { singlePdf, zipFile } from 'utils/downloadFile'
import CalendarPaper from '../../../../components/CalenderStyle/CalenderPaper'
import { EmptyElement } from '../../../../components/UIComponents/CommonStyledDiv'

const InterviewerDashboardRoles = () => {
  const params = useParams()
  const dispatch = new useDispatch()
  const navigate = useNavigate()
  const carouselRef = useRef(null)
  const [scrollable, setScrollable] = useState(false)
  const carouselRef1 = useRef(null)

  const carouselRef2 = useRef(null)
  const [previewDrawer, setPreviewDrawer] = useState(false)
  const UserData = useSelector(state => state?.auth?.userData)
  const corporateData = useSelector(state => state?.auth?.corporateData)
  const singleRoleData = useSelector(state => state?.corporate?.singleRoleData)
  const [isDownloadingCV, setIsDownloadingCV] = useState(false)
  const [page, setPage] = useState(0)
  const [sortBy, setSortBy] = useState('')
  const [search, setSearch] = useState('')
  const [candidateList, setCandidateList] = useState([])
  const [statusFilter, setStatusFilter] = useState([])
  const [candidateRating, setCandidateRating] = useState([])
  const [filterData, setFilterData] = useState({
    status: '',
    score: '',
  })
  const [cardData, setCardData] = useState([])
  const [activeCard, setActiveCard] = useState(0)
  const [roleCard, setRoleCard] = useState([])
  const [activeCardRole, setActiveCardRole] = useState(0)
  const [currentSelection, setCurrentSelection] = useState(null)
  const [currentTimeDetails, setCurrentTimeDetails] = useState(null)
  const [activeTime, setActiveTime] = useState(0)
  const [selectedID, setSelectedID] = useState([])
  const [isAllSelected, setIsAllSelected] = useState(false)
  const [selectedDate, setSelectedDate] = useState(null)
  const [selectedTime, setSelectedTime] = useState(null)
  const UserId = params?.userId ? params?.userId : UserData?._id
  useEffect(() => {
    const container = carouselRef.current
    setScrollable(container?.scrollWidth > container?.clientWidth)
  }, [])

  useEffect(() => {
    dispatch(getSingleRoleData(0,params?.roleId, 1))
  }, [params?.roleId])
  useEffect(() => {
    ;(async () => {
      let responce = await dispatch(
        getListOfDatesInterviewer(UserId, params?.roleId)
      )
      const targetDateFormatted = `${params?.date}T00:00:00.000Z`
      const targetEntry = responce?.panelDetails?.find(
        entry => entry.date === targetDateFormatted
      )
      if (targetEntry) {
        const newData = responce?.panelDetails?.filter(
          entry => entry.date !== targetDateFormatted
        )
        newData.unshift(targetEntry)
        setCardData(newData)
        if (newData?.[0]?.date) {
          setSelectedDate(
            moment(newData?.[0]?.date).format('YYYY-MM-DD')?.toString()
          )
        } else {
          setSelectedDate(null)
        }
      }
    })()
    return () => {}
  }, [UserId])

  useEffect(() => {
    ;(async () => {
      getCandidateList()
    })()
    return () => {}
  }, [page, sortBy, search, filterData, params?.roleId, selectedTime, UserId])

  useEffect(() => {
    ;(async () => {
      if (selectedDate) {
        let param = {
          userId: UserId,
          roleId: params?.roleId,
          startDate: selectedDate,
          endDate: selectedDate,
          page: 0,
        }
        let responce = await dispatch(getListOfRolesForInterviwer(param))
        if (responce?.panelDetails?.length > 0) {
          const targetEntry = responce?.panelDetails?.find(
            entry => entry.interviewId === params?.interID
          )

          const newData = responce?.panelDetails?.filter(
            entry => entry.interviewId !== params?.interID
          )
          newData.unshift(targetEntry)
          setRoleCard(newData || [])
          setActiveCardRole(0)
          setActiveTime(0)
          setCurrentSelection(newData?.[0])
          setCurrentTimeDetails(newData?.[0]?.panelList?.[0])
          setSelectedTime(newData?.[0]?.panelList?.[0])
        } else {
          setRoleCard([])
          setActiveCardRole(0)
          setActiveTime(0)
          setCurrentSelection(null)
          setCurrentTimeDetails(null)
          setSelectedTime(null)
        }
      }
    })()
    return () => {}
  }, [selectedDate, UserId])

  const getCandidateList = async () => {
    setIsAllSelected(false)
    setSelectedID([])
    setCandidateList([])
    let params = {
      userId: UserId,
      page: page,
      sortBy: sortBy,
      search: search,
      filterData: filterData,
      roleId: params?.roleId,
      startTime: selectedTime?.startDateWithTimestamp,
      stage: currentSelection?.interviewRound,
    }
    if(currentSelection?.interviewRound)
    {
    let response = await dispatch(getListOfCandidateForRoleTOInterview(params))
    setCandidateList(response)
    }
  }

  const handleScroll = () => {
    const container = carouselRef?.current
    setScrollable(container?.scrollWidth > container?.clientWidth)
  }

  const scrollToLeft = () => {
    const container = carouselRef.current
    container.scrollLeft -= container.clientWidth
  }

  const scrollToRight = () => {
    const container = carouselRef.current
    container.scrollLeft += container.clientWidth
  }

  const handleScroll1 = () => {
    const container = carouselRef1?.current
    setScrollable(container?.scrollWidth > container?.clientWidth)
  }

  const scrollToLeft1 = () => {
    const container = carouselRef1.current
    container.scrollLeft -= container.clientWidth
  }

  const scrollToRight1 = () => {
    const container = carouselRef1.current
    container.scrollLeft += container.clientWidth
  }

  const handleScroll2 = () => {
    const container = carouselRef2?.current
    setScrollable(container?.scrollWidth > container?.clientWidth)
  }

  const scrollToLeft2 = () => {
    const container = carouselRef2.current
    container.scrollLeft -= container.clientWidth
  }

  const scrollToRight2 = () => {
    const container = carouselRef2.current
    container.scrollLeft += container.clientWidth
  }
  const updateStatus = async data => {
    if (selectedID?.length > 0) {
      let payload = {
        isAll: isAllSelected,
        file: false,
        status: data,
        parametersScore: {},
      }
      if (!isAllSelected) {
        payload['studentIds'] = selectedID?.map(studentId => ({ studentId }))
      }

      let response = await dispatch(
        bulkFileUploadStatus({
          interviewId: currentSelection?.interviewId,
          interviewerID: UserId,
          payload: payload,
        })
      )
      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage('Status Updated Successfully!')
        setSelectedID([])
        getCandidateList()
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
    }
  }

  const joinInterview = () => {
    window.open(currentTimeDetails?.link, '_blank')
  }

  const handleDownloadCV = async () => {
    if (isDownloadingCV) return
    if (!selectedID || selectedID.length === 0) {
      ErrorMessage('Please select at least one candidate to download CV')
      return
    }

    const selectedCandidates =
      candidateList?.result?.filter(item =>
        selectedID.includes(item?.studentInterviewMap?.studentId)
      ) || []

    const payload = {
      email: UserData?.email || '',
      instName: corporateData?.name || '',
      state: corporateData?.state || '',
      city: corporateData?.city || '',
      user: `${UserData?.first_name || ''} ${UserData?.last_name || ''}`.trim(),
      studentIds: [selectedID],
      roleId: params?.roleId,
    }

    setIsDownloadingCV(true)
    try {
      const response = await dispatch(resumeBulkDownloadJobRoles(payload))
      if (response?.data) {
        if (selectedID.length === 1) {
          const student = selectedCandidates[0]?.studentInterviewMap?.student
          const studentName =
            `${student?.firstName || ''} ${student?.lastName || ''}`.trim() ||
            'Resume'
          await singlePdf(response, studentName, selectedID[0])
        } else if (selectedID.length <= 5) {
          await zipFile(response.data)
        } else {
          SuccessMessage(
            'Bulk resume download initiated. You will receive an email when ready.'
          )
        }
      } else {
        ErrorMessage('Failed to download CV')
      }
    } catch (e) {
      ErrorMessage('Failed to download CV')
    } finally {
      setIsDownloadingCV(false)
    }
  }

  const headerRender = ({ value, onChange }) => {
    return <CalendarPaper value={value} onChange={onChange} />
  }

  return (
    <Wrapper>
      <Flex alignCenter spaceBetween>
        <HeaderFlex>
          <UserName>Interview & Drives</UserName>
          <Button.Secondary
            isBorder={true}
            text="View Overall"
            onClick={() => navigate(-1)}
            height={'32px'}
          />
        </HeaderFlex>
      </Flex>
      <Row>
        <Col span={18}>
          {cardData?.length > 0 ? (
            <ScrollContainer>
              <CarouselWrapper ref={carouselRef} onScroll={handleScroll}>
                <LeftArrow show={false} onClick={scrollToLeft}>
                  <LeftArrowIcon />
                </LeftArrow>
                <CardRow>
                  {cardData?.map((Item, index) => (
                    <InfoCards
                      width={'200px'}
                      height="115px"
                      activeCard={activeCard}
                      setActiveCard={setActiveCard}
                      Item={Item}
                      id={index}
                      date={Item?.date}
                      count={Item?.studentsCount}
                      setData={setSelectedDate}
                      setSelectedDate={setSelectedDate}
                      isSetData={true}
                      setFromDate={setSelectedDate}
                      fromDate={selectedDate}
                      key={index + 'cardKey'}
                    />
                  ))}
                </CardRow>
                <RightArrow show={scrollable} onClick={scrollToRight}>
                  <RightArrowIconcircle />
                </RightArrow>
              </CarouselWrapper>
            </ScrollContainer>
          ) : (
            <div style={{ padding: '20px' }}>
              <EmptyCard width={'200px'} height="115px" />
            </div>
          )}
          {currentTimeDetails?.mode && (
            <DriveModeText>
              Drive Mode{' '}
              <span>
                {currentTimeDetails?.mode === 'EXTERNAL_LINK'
                  ? 'Online'
                  : 'Offline'}
              </span>
            </DriveModeText>
          )}
          {roleCard?.length > 0 ? (
            <ScrollContainer>
              <CarouselWrapper ref={carouselRef1} onScroll={handleScroll1}>
                <LeftArrow show={false} onClick={scrollToLeft1}>
                  <LeftArrowIcon />
                </LeftArrow>
                <CardRow margin={true}>
                  {roleCard?.map((Item, index) => (
                    <InfoCards
                      isRole={true}
                      width={'200px'}
                      height="115px"
                      activeCard={activeCardRole}
                      setActiveCard={setActiveCardRole}
                      id={index}
                      date={Item?.interviewRound}
                      count={Item?.totalStudents}
                      title={Item?.roleName}
                      Item={Item}
                      setCurrentSelection={setCurrentSelection}
                      setCurrentTimeDetails={setCurrentTimeDetails}
                      setSelectedTime={setSelectedTime}
                      setActiveTime={setActiveTime}
                      key={index + 'interviewRound'}
                    />
                  ))}
                </CardRow>
                <RightArrow show={false} onClick={scrollToRight1}>
                  <RightArrowIconcircle />
                </RightArrow>
              </CarouselWrapper>
            </ScrollContainer>
          ) : (
            <div style={{ padding: '20px' }}>
              <EmptyCard width={'200px'} height="115px" />
            </div>
          )}
          {currentSelection?.panelList?.length > 0 && (
            <ScrollContainer>
              <CarouselWrapper ref={carouselRef2} onScroll={handleScroll2}>
                <LeftArrow show={false} time={true} onClick={scrollToLeft2}>
                  <LeftArrowIcon />
                </LeftArrow>
                <CardRow>
                  {currentSelection?.panelList?.map((Item, index) => (
                    <TimeCard
                      width={'200px'}
                      height="55px"
                      index={index}
                      activeTime={activeTime}
                      setActiveTime={setActiveTime}
                      Item={Item}
                      setSelectedTime={setSelectedTime}
                      setCurrentTimeDetails={setCurrentTimeDetails}
                      text1={Item?.startAMPMTime}
                      text2={Item?.endAMPMTime}
                      key={index + 'timeCard'}
                    />
                  ))}
                </CardRow>
                <RightArrow show={false} time={true} onClick={scrollToRight2}>
                  <RightArrowIconcircle />
                </RightArrow>
              </CarouselWrapper>
            </ScrollContainer>
          )}
        </Col>
        <Col span={6}>
          <CalenderStyled
            allDate={cardData}
            setFromDate={setSelectedDate}
            fromDate={selectedDate}
            headerRender={headerRender}
          />
        </Col>
      </Row>
      <Row
        style={{
          paddingBottom: '10px',
          paddingTop: '10px',
          background: 'white',
        }}
      >
        <Col span={10}>
          <Flex alignCenter spaceBetween centerVertically>
            <HeaderFlex gap={true}>
              <Statustext style={{ whiteSpace: 'nowrap' }}>
                Select Status
              </Statustext>
              <Tooltip title={'Move to Next Round'}>
                <EmptyElement
                  onClick={() => updateStatus('MOVE_TO_NEXT_ROUND')}
                >
                  <SelectTickIcon />
                </EmptyElement>
              </Tooltip>
              <Tooltip title={'Reject'}>
                <EmptyElement onClick={() => updateStatus('REJECT')}>
                  <RejectIcon />
                </EmptyElement>
              </Tooltip>
              <Tooltip title={'Hold to Compare'}>
                {' '}
                <EmptyElement onClick={() => updateStatus('HOLD_TO_COMPARE')}>
                  <HoldtocompareIcon />
                </EmptyElement>
              </Tooltip>
              <Tooltip title={'Absent'}>
                <EmptyElement onClick={() => updateStatus('ABSENT')}>
                  <AbsentIcon />
                </EmptyElement>
              </Tooltip>
              <EmptyElement
                onClick={
                  selectedID?.length === 0 || isDownloadingCV
                    ? undefined
                    : handleDownloadCV
                }
                style={{
                  opacity:
                    selectedID?.length === 0 || isDownloadingCV ? 0.5 : 1,
                  cursor:
                    selectedID?.length === 0
                      ? 'not-allowed'
                      : isDownloadingCV
                      ? 'wait'
                      : 'pointer',
                  pointerEvents: 'auto',
                }}
              >
                <ResumeDownload />
              </EmptyElement>
            </HeaderFlex>
          </Flex>
        </Col>
        <Col span={14}>
          <Flex alignCenter spaceBetween flexEnd style={{ gap: '10px' }}>
            <DownlaodUpload
              currentTimeDetails={currentTimeDetails}
              currentSelection={currentSelection}
              getCandidateList={getCandidateList}
            />
            <Button.Secondary
              isBorder={true}
              onClick={() => setPreviewDrawer(true)}
              text="View Details"
            />
            {currentTimeDetails?.mode === 'EXTERNAL_LINK' && (
              <Button.Primary
                text={
                  currentSelection?.interviewType === 'GROUP'
                    ? 'Join Group Discussion'
                    : 'Join Interview'
                }
                onClick={joinInterview}
              />
            )}
            &nbsp;&nbsp;
          </Flex>
        </Col>
      </Row>

      <InterviewerTabel
        candidateList={candidateList}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        filterData={filterData}
        setFilterData={setFilterData}
        page={page}
        setPage={setPage}
        setSortBy={setSortBy}
        setSearch={setSearch}
        search={search}
        selectedID={selectedID}
        setSelectedID={setSelectedID}
        candidateRating={candidateRating}
        setCandidateRating={setCandidateRating}
        singleRoleData={singleRoleData}
        currentSelection={currentSelection}
        currentTimeDetails={currentTimeDetails}
        getCandidateList={getCandidateList}
        isAllSelected={isAllSelected}
        setIsAllSelected={setIsAllSelected}
        selectedTime={selectedTime}
      />
      {previewDrawer && (
        <PreviewRoleDrawer
          previewDrawer={previewDrawer}
          previewRoleData={singleRoleData}
          setPreviewDrawer={setPreviewDrawer}
          currentTimeDetails={currentTimeDetails}
          currentSelection={currentSelection}
        />
      )}
    </Wrapper>
  )
}

export default InterviewerDashboardRoles
